<tec-tile
	[id]="OPERATION_TYPE.CONNECTIONS"
	[title]="operation.title"
	[formGroup]="group"
	[subtitle]="operation.description"
	[icon]="operation.icon"
>
	<tec-tile
		[title]="'WORKFLOWS.FORM.OPERATIONS.FINANCIAL_EVALUATION_TYPE.TITLE' | translate"
		[subtitle]="'WORKFLOWS.FORM.OPERATIONS.FINANCIAL_EVALUATION_TYPE.DESCRIPTION' | translate"
	>
		<div class="grid grid-i2">
			<tec-card-select
				[tagImg]="{ icon: 'icon-trending-up', status: 'control' }"
				[title]="'WORKFLOWS.FORM.OPERATIONS.FINANCIAL_EVALUATION_TYPE.FINANCIAL_EVALUATION' | translate"
				[description]="'WORKFLOWS.FORM.OPERATIONS.FINANCIAL_EVALUATION_TYPE.FINANCIAL_EVALUATION_DESCRIPTION' | translate"
				[selected]="evalType === 'scoring'"
				(selectedChange)="setEvalType('scoring', $event)"
			/>
			<tec-card-select
				[tagImg]="{ icon: 'icon-bank', status: 'notice' }"
				[title]="'WORKFLOWS.FORM.OPERATIONS.FINANCIAL_EVALUATION_TYPE.VERIFY_IDENTITY' | translate"
				[description]="'WORKFLOWS.FORM.OPERATIONS.FINANCIAL_EVALUATION_TYPE.VERIFY_IDENTITY_DESCRIPTION' | translate"
				[selected]="evalType === 'verify'"
				(selectedChange)="setEvalType('verify', $event)"
			/>
		</div>
	</tec-tile>

	@if (evalType === 'scoring') {
		<tec-tile
			[title]="'WORKFLOWS.FORM.OPERATIONS.FINANCIAL_EVALUATION_METHODS' | translate"
			[subtitle]="'WORKFLOWS.FORM.OPERATIONS.FINANCIAL_EVALUATION_METHODS_DESCRIPTION' | translate"
		>
			<div class="grid grid-i3">
				<tec-card-select
					[tagImg]="{ icon: 'icon-bank', status: 'notice' }"
					[title]="'WORKFLOWS.FORM.OPERATIONS.CONNECTION_BANK_SCORING' | translate"
					[description]="'WORKFLOWS.FORM.OPERATIONS.CONNECTION_BANK_SCORING_DESCRIPTION' | translate"
					[tags]="[{ label: 'WORKFLOWS.DETAIL.AUTOMATIC' | translate | uppercase, status: 'success' }]"
					[disabled]="isConnectionDisabled(CONNECTION_TYPE.BANK_SCORING)"
					[selected]="hasConnection(CONNECTION_TYPE.BANK_SCORING)"
					(selectedChange)="changeAvailableFinancialEvaluation($event, CONNECTION_TYPE.BANK_SCORING)"
				/>
				<tec-card-select
					[tagImg]="{ icon: 'icon-briefcase', status: 'control' }"
					[title]="'WORKFLOWS.FORM.OPERATIONS.CONNECTION_WORKLIFE' | translate"
					[description]="'WORKFLOWS.FORM.OPERATIONS.CONNECTION_WORKLIFE_DESCRIPTION' | translate"
					[tags]="[{ label: 'WORKFLOWS.DETAIL.AUTOMATIC' | translate | uppercase, status: 'success' }]"
					[disabled]="isConnectionDisabled(CONNECTION_TYPE.WORK_LIFE)"
					[selected]="hasConnection(CONNECTION_TYPE.WORK_LIFE)"
					(selectedChange)="changeAvailableFinancialEvaluation($event, CONNECTION_TYPE.WORK_LIFE)"
				/>
				<tec-card-select
					[tagImg]="{ icon: 'icon-file' }"
					[title]="'WORKFLOWS.FORM.OPERATIONS.CONNECTION_IRPF' | translate"
					[description]="'WORKFLOWS.FORM.OPERATIONS.CONNECTION_IRPF_DESCRIPTION' | translate"
					[tags]="[{ label: 'WORKFLOWS.DETAIL.AUTOMATIC' | translate | uppercase, status: 'success' }]"
					[disabled]="isConnectionDisabled(CONNECTION_TYPE.IRPF)"
					[selected]="hasConnection(CONNECTION_TYPE.IRPF)"
					(selectedChange)="changeAvailableFinancialEvaluation($event, CONNECTION_TYPE.IRPF)"
				/>
			</div>
			@if (getDuplicateConnection()?.length) {
				<tec-divider />
				@for (doc of getDuplicateConnection(); track $index) {
					<div style="gap: 8px; display: flex; flex-flow: column;">
						<span>{{ doc?.docInfo?.title?.toUpperCase() }}</span>
						<tec-alert
							[msg]="'WORKFLOWS.FORM.OPERATIONS.DUPLICATE_OPERATION_DISCLAIMER' | translate"
							[type]="'message'"
							[icon]="'icon-info'"
							hiddenCloseButton
						/>
					</div>
				}
			}
		</tec-tile>
	}

	@if (evalType) {
		<!-- Configuración avanzada -->
		<app-workflow-form-advanced-collapse [expanded]="id">
			<div class="item-group">
				<tec-item
					[classes]="['item--outline']"
					[title]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIES' | translate"
					[tagImage]="{ icon: 'icon-pending-check' }"
				>
					<tec-list-detail>
						<span>{{ 'WORKFLOWS.FORM.OPERATIONS.NUM_TRIES_DESCRIPTION' | translate }}</span>
					</tec-list-detail>
					<tec-input
						type="number"
						formControlName="total_tries"
						[hasError]="reactiveFormService.hasError(group.get('total_tries'))"
					/>
				</tec-item>
			</div>
		</app-workflow-form-advanced-collapse>
	}
</tec-tile>
